module.exports = __webpack_public_path__ + "img/banner.d8ec3700.png";